export { default } from './cannabinoid-grid-item';
